import {
  EXPAND_SIDE_MENU,
  COLLAPSE_SIDE_MENU
} from '../actionTypes/sideMenu'

export const expandSideMenu = () => {
  return {
    type: EXPAND_SIDE_MENU,
  }
}
export const collapseSideMenu = () => {
  return {
    type: COLLAPSE_SIDE_MENU
  }
}